// extracted by mini-css-extract-plugin
export default {"footerContainer":"Playlists_footerContainer__W8HhJ"};